export const composeOpenAiPromptFromSections = (values = {}) => {
  const blocks = [
    values.promptRole?.trim() && `## Rol y objetivo\n${values.promptRole.trim()}`,
    values.promptRules?.trim() && `## Reglas de conducta\n${values.promptRules.trim()}`,
    values.promptKnowledge?.trim() && `## Información del negocio\n${values.promptKnowledge.trim()}`,
    values.promptRestrictions?.trim() && `## Restricciones\n${values.promptRestrictions.trim()}`,
    values.promptExamples?.trim() && `## Ejemplos\n${values.promptExamples.trim()}`,
  ].filter(Boolean);

  if (blocks.length > 0) {
    return blocks.join("\n\n");
  }

  return values.prompt?.trim() || "";
};

export const DEFAULT_HANDOFF_KEYWORDS =
  "hablar con una persona, hablar con alguien, agente humano, persona real, atención humana, quiero un humano, operador, asesor humano";

export const DEFAULT_HANDOFF_AI_TRIGGER = "Acción: Transferir a atención humana";

export const DEFAULT_HANDOFF_MESSAGE =
  "Perfecto, te comunico con un agente humano. Sigamos con lo que estábamos conversando.";
